import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";
import { FAQS } from "@/data/content";

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="section-y relative"
        >
            <div className="container-em max-w-4xl">
                <Reveal>
                    <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                        Häufige Fragen
                    </span>
                </Reveal>
                <Reveal delay={0.05}>
                    <h2
                        data-testid="faq-title"
                        className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight text-balance"
                    >
                        Gut zu wissen.
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <Accordion
                        type="single"
                        collapsible
                        className="mt-12 w-full"
                    >
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-border/70"
                            >
                                <AccordionTrigger className="text-left font-display text-xl sm:text-2xl text-foreground py-6 hover:no-underline hover:text-primary transition-colors">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-foreground/75 text-base leading-relaxed pb-6 pr-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
